import {
  ITemplateResponse,
  ITemplateResponsePagination,
  TConvertKeys,
  TNullable,
} from './common';
import { IUploadDocumentData } from './documents';
import { IParticipant } from './participants';
import { TUserSummary } from './user';

interface IBaseActionEvent {
  id: string;
  user_institution_role_id: string;
  entity_id: string;
  meta: unknown;
  created_at: string;
  user?: Partial<TUserSummary>;
}

export interface IChatActionEvent extends IBaseActionEvent {
  type: EChatEvent;
}

type TActionEvent = IChatActionEvent;
export type TActionEventCamel = TConvertKeys<TActionEvent>;

export enum EChatEvent {
  JOINED = 'chat_joined',
  LEFT = 'chat_left',
  ENDED = 'chat_ended',
  CHAT_DECLINED = 'chat_declined',
  CHAT_ACCEPTED = 'chat_accepted',

  WAITING_ROOM_ENDED = 'waiting_room_ended',
  CANARY_REQUEST = 'canary_request',
  MEDWAND_REQUEST = 'medwand_request',
  // TODO: maybe it will be taken out of here
  // PARTICIPANT_REMOVED = 'chat_participant_removed',
  // PARTICIPANT_ADDED = 'chat_participant_added',
  // WAITING_ROOM_JOINED = 'waiting_room_joined',
  // WAITING_ROOM_LEFT = 'waiting_room_left',
}

export interface IChatMessage {
  id: string;
  chat_id: string;
  user_institution_role_id: string;
  content: string;
  created_at: string;
  isRead: { at: string; by: string }[];
  user?: Partial<TUserSummary>;
}

export interface IChatData {
  id: string;
  appointment_id?: string;
  participants: IParticipant[];
  documents: IUploadDocumentData[];
  messages?: IChatMessage[];
  created_at: string;
  events: IChatActionEvent[];
  details: {
    actual_duration: TNullable<number>;
  };
}

export type TChatMessageCamel = TConvertKeys<IChatMessage>;
export type TChatEventCamel = TConvertKeys<IChatActionEvent>;
export type TChatDataCamel = TConvertKeys<IChatData>;

export type TChatResponse = ITemplateResponse<IChatData>;
export type TChatsResponse = ITemplateResponse<
  IChatData[],
  ITemplateResponsePagination
>;

// Query params for the chats list: page is 1-indexed, per_page = -1 returns
// all results, institution_id optionally filters chats by institution.
export interface IGetChatsParams {
  page?: number;
  per_page?: number;
  institution_id?: string;
}

export type TChatMessageResponse = ITemplateResponse<IChatMessage>;

export interface IChatMessageRequest {
  user_institution_role_id: string;
  content: string;
}

export type TChatMessageRequestCamel = TConvertKeys<IChatMessageRequest>;

export interface IPatchChatRequest {
  user_institution_role_ids?: string[];
  document_ids?: string[];
}

export type TPatchChatRequestCamel = TConvertKeys<IPatchChatRequest>;

export interface IPutChatParticipantsRequest {
  user_institution_role_id: string;
  /** Ad-hoc chats only: invites the user to the video call of the chat too. */
  with_encounter?: boolean;
}

export type TPutChatParticipantsRequestCamel =
  TConvertKeys<IPutChatParticipantsRequest>;

export interface IPostChatEventRequest {
  user_institution_role_id: string;
  type: EChatEvent;
}
export type TPostChatEventRequestCamel = TConvertKeys<IPostChatEventRequest>;

export interface ICreateChatRequest {
  appointment_id?: string;
  user_institution_role_ids: string[];
  document_ids?: string[];
  with_encounter?: boolean;
}

export type TCreateChatRequestCamel = TConvertKeys<ICreateChatRequest>;
